import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBhtRbo3sxctU4jVN0sRd-qVH0YDCgRl8U",
  authDomain: "brandlifts-38ffc.firebaseapp.com",
  projectId: "brandlifts-38ffc",
  storageBucket: "brandlifts-38ffc.firebasestorage.app",
  messagingSenderId: "897344010537",
  appId: "1:897344010537:web:1aa52a6abedb09faed5f38",
  measurementId: "G-01XMRMP280",
};

const app = initializeApp(firebaseConfig);

const analyticsPromise =
  typeof window !== "undefined"
    ? isSupported()
        .then((supported) => {
          if (!supported) {
            return null;
          }
          const analytics = getAnalytics(app);
          logEvent(analytics, "brandlifts_site_loaded");
          return analytics;
        })
        .catch(() => null)
    : Promise.resolve(null);

export { app, analyticsPromise };
